import { hashFile } from "lib/helpers";

const cachedUrls = {};

/**
 * @param {monaco.editor.IStandaloneCodeEditor} editor
 * @param {File} file
 */
export async function insertImage(editor, file, options = {}) {
	const { imageSizeLimit = 2.4 * 1024 * 1024, uploadImage } = options;
	await editor.getAction('editor.action.insertLineAfter').run();
	const { lineNumber } = editor.getPosition();

	const lineStartRange = new monaco.Range(lineNumber, 1, lineNumber, 1);

	if (file.size > imageSizeLimit) {
		const limitSizeInMb = (imageSizeLimit / 1024 / 1024).toPrecision(2);
		const fileSizeInMb = (file.size / 1024 / 1024).toPrecision(3);
		const errorText = `[仅支持不超过 ${limitSizeInMb}M 的图片, 该图片过大(${fileSizeInMb}M)]`;
		return editor.executeEdits("insert-image-error", [{
			identifier: 'insert',
			range: lineStartRange,
			text: errorText,
			forceMoveMarkers: true
		}], [new monaco.Selection(lineNumber, 1, lineNumber, errorText.length)]);
	}

	const hash = await hashFile(file);
	const uploadRemark = `[正在上传图片...][@${hash}]`;
	editor.executeEdits('insert-image-uploading', [{
		identifier: 'insert',
		range: lineStartRange,
		text: uploadRemark,
		forceMoveMarkers: true,
	}]);

	const replaceRemark = text => {
		const model = editor.getModel();
		const lineCount = model.getLineCount();
		let targetRange = null;
		for (let lineNumber = 1; lineNumber <= lineCount; lineNumber++) {
			const lineContent = model.getLineContent(lineNumber);
			const columnNumber = lineContent.indexOf(uploadRemark) + 1;
			if (columnNumber > 0) {
				targetRange = new monaco.Range(
					lineNumber, columnNumber,
					lineNumber, columnNumber + uploadRemark.length
				);
				break;
			}
		}
		if (targetRange) {
			editor.executeEdits("replace-image-mark", [{
				identifier: 'replace',
				range: targetRange,
				text,
				forceMoveMarkers: true
			}])
		}
	};

	let url = cachedUrls[hash];
	if (!url) {
		try {
			const result = await uploadImage(file);
			cachedUrls[hash] = url = result.url;
		} catch (err) {
			replaceRemark('上传失败：' + (err.msg || err.message || '服务器错误'));
			return;
		}
	}
	if (url) {
		replaceRemark(`![${file.name}](${url})`);
	}
}



// WEBPACK FOOTER //
// ./lib/editor/MarkdownEditor/actions/insertImage.js